import useDocumentTitle from '../hooks/useDocument';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import Header from '../components/header';

import {
  useForm,
  isNotEmpty,
  isEmail,
  isInRange,
  hasLength,
} from '@mantine/form';
import {
  Button,
  rem,
  createStyles,
  Container,
  Group,
  Paper,
  FileButton,
  Text,
  TextInput,
  NumberInput,
  Box,
  Select,
} from '@mantine/core';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

const useStyles = createStyles(theme => ({
  hero: {
    position: 'relative',
    backgroundImage: 'url(./assets/img/join-us.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  container: {
    height: rem(500),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    paddingBottom: `calc(${theme.spacing.xl} * 6)`,
    zIndex: 1,
    position: 'relative',

    [theme.fn.smallerThan('sm')]: {
      height: rem(500),
      paddingBottom: `calc(${theme.spacing.xl} * 3)`,
    },
  },
}));

function JobForm() {
  const {classes} = useStyles();
  const [file, setFile] = useState<File | null>(null);
  useDocumentTitle('Careers-Quality-Home-Healthcare');

  const form = useForm({
    initialValues: {
      title: '',
      first_name: '',
      last_name: '',
      email: '',
      city: '',
      phone: 7986544560,
      experience: '',
    },

    validate: {
      first_name: hasLength(
        {min: 2, max: 10},
        'Name must be 2-10 characters long',
      ),
      last_name: hasLength(
        {min: 2, max: 10},
        'Name must be 2-10 characters long',
      ),

      title: isNotEmpty('Enter your Title'),

      email: isEmail('Invalid email'),
      city: hasLength({min: 2, max: 22}, 'City must be 2-10 characters long'),
      phone: isInRange(
        {min: 10, max: 12},
        'Phone number must have at least 9 numbers',
      ),
    },
  });
  return (
    <div className="body-wrapper">
      <Header />
      <div className="bg-image-19 bg-image">
        {/*<Overlay
          gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 50%)"
          opacity={1}
          zIndex={0}
        />*/}
        <Container className={classes.container}>
          <h1 className="page-title top-a overlay2 overlay_1">
            Register with us
          </h1>
          <h3 className="page-title top-a overlay overlay_1">
            Upload your CV to be considered for future vacancies.
          </h3>
        </Container>
      </div>

      <div className="ltn__page-details-area ltn__service-details-area mb-3 pt-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="color-border mb-3"></div>
              <h1 className="text-left compassion mt-5">
                Job Application form
              </h1>
              <p className="values_p">
                Use this form to apply for one of our vacancies or to upload
                your CV for consideration with future vacancies.
              </p>
              <h5 className="mt-3">Your name & contact details</h5>
              <div className="row mt-3">
                <Paper withBorder shadow="lg" p={40} mt={30} radius="lg">
                  <Box
                    component="form"
                    maw={400}
                    mx="auto"
                    onSubmit={form.onSubmit(() => {})}
                  >
                    <Select
                      size="xl"
                      radius="md"
                      label="Title"
                      placeholder="Please select..."
                      data={[
                        {value: 'Mr', label: 'Mr'},
                        {value: 'Miss', label: 'Miss'},
                        {value: 'Mrs', label: 'Mrs'},
                        {value: 'Dr', label: 'Dr'},
                      ]}
                      {...form.getInputProps('title')}
                      styles={theme => ({
                        item: {
                          // applies styles to selected item
                          '&[data-selected]': {
                            '&, &:hover': {
                              backgroundColor: '#485e21',
                              color: '#fff',
                            },
                          },

                          // applies styles to hovered item (with mouse or keyboard)
                          '&[data-hovered]': {},
                        },
                        label: {
                          color: '#485e21',
                        },
                        input: {},
                      })}
                    />
                    <TextInput
                      label="First Name"
                      radius="15"
                      mt="md"
                      placeholder="Name"
                      withAsterisk
                      {...form.getInputProps('first_name')}
                      styles={theme => ({
                        label: {
                          color: '#485e21',
                        },
                        input: {
                          borderColor: '#485e21',
                          backgroundColor: '#485e21',
                        },
                      })}
                    />
                    <TextInput
                      label="Last Name"
                      mt="md"
                      radius="md"
                      placeholder="Last Name"
                      withAsterisk
                      {...form.getInputProps('last_name')}
                      styles={theme => ({
                        label: {
                          color: '#485e21',
                        },
                        input: {
                          borderColor: '#485e21',
                          backgroundColor: '#485e21',
                        },
                      })}
                    />

                    <TextInput
                      label="Email"
                      placeholder="Your email"
                      withAsterisk
                      mt="md"
                      radius="md"
                      styles={theme => ({
                        label: {
                          color: '#485e21',
                        },
                        input: {
                          borderColor: '#485e21',
                          backgroundColor: '#485e21',
                        },
                      })}
                      {...form.getInputProps('email')}
                    />

                    <NumberInput
                      label="Telephone/Mobile"
                      placeholder="Phone"
                      min={10}
                      max={12}
                      withAsterisk
                      mt="md"
                      radius="md"
                      styles={theme => ({
                        label: {
                          color: '#485e21',
                        },
                        input: {
                          borderColor: '#485e21',
                          backgroundColor: '#485e21',
                        },
                      })}
                      {...form.getInputProps('phone')}
                    />
                    <TextInput
                      label="City"
                      placeholder="City"
                      withAsterisk
                      mt="md"
                      radius="md"
                      styles={theme => ({
                        label: {
                          color: '#485e21',
                        },
                        input: {
                          borderColor: '#485e21',
                          backgroundColor: '#485e21',
                        },
                      })}
                      {...form.getInputProps('city')}
                    />

                    <Select
                      size="xl"
                      radius="md"
                      label="Do you have the right to work in the UK?"
                      placeholder="Please select..."
                      data={[
                        {value: 'Yes', label: 'Yes'},
                        {value: 'No', label: 'No'},
                      ]}
                      {...form.getInputProps('experience')}
                      styles={theme => ({
                        item: {
                          // applies styles to selected item
                          '&[data-selected]': {
                            '&, &:hover': {
                              backgroundColor: '#485e21',
                              color: '#fff',
                            },
                          },

                          // applies styles to hovered item (with mouse or keyboard)
                          '&[data-hovered]': {},
                        },
                        label: {
                          color: '#485e21',
                        },
                        input: {},
                      })}
                    />

                    <>
                      <Group position="center" mt={15}>
                        <FileButton
                          onChange={setFile}
                          accept="image/png,image/jpeg"
                        >
                          {props => (
                            <Button
                              {...props}
                              size="lg"
                              styles={theme => ({
                                root: {
                                  backgroundColor: '#485e21',
                                  border: 0,

                                  '&:not([data-disabled])': theme.fn.hover({
                                    backgroundColor: '#21485e',
                                    color: '#ffffff',
                                  }),
                                },
                              })}
                            >
                              Upload CV
                            </Button>
                          )}
                        </FileButton>
                      </Group>

                      {file && (
                        <Text size="sm" align="center" mt="sm">
                          Picked file: {file.name}
                        </Text>
                      )}
                    </>

                    <Group position="center" mt="md">
                      <Button
                        size="lg"
                        type="submit"
                        styles={theme => ({
                          root: {
                            backgroundColor: '#485e21',
                            border: 0,

                            '&:not([data-disabled])': theme.fn.hover({
                              backgroundColor: '#21485e',
                              color: '#ffffff',
                            }),
                          },
                        })}
                      >
                        Submit Form
                      </Button>
                    </Group>
                  </Box>
                </Paper>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/care">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Complex care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8"></div>
          </div>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </div>
  );
}

export default JobForm;
